import React, { useState } from 'react'
import Button from './Button'
import Menu from './Menu'

import './styles/splitButton.scss'

const SplitButton = (props) => {
    const {
        cssClass, btnClass, label, style, disabled, buttons,
    } = props

    const [show, setShow] = useState(false)

    const toggle = () => setShow((prevShow) => (!prevShow))

    let componentClass = 'uc-splitButton'
    componentClass += cssClass ? ` ${cssClass}` : ''

    let btnCss = 'spaceBetween'
    btnCss += btnClass ? ` ${btnClass}` : ''
    btnCss += show ? ' active' : ''

    const list = buttons.map(({ icon, label, onClick }) => (
        <div className="menu-btn" onClick={onClick}>
            <i className={icon} />
            {label}
        </div>
    ))

    return (
        <div className={componentClass} style={style}>
            <Menu
                cssClass="btn-menu"
                dir="bottom"
                list={list}
                width="100%"
                onClose={() => setShow(false)}
            >
                <Button
                    label={label}
                    cssClass={btnCss}
                    disabled={disabled}
                    onClick={toggle}
                >
                    {show ? <i className="arrow-icon fa-regular fa-chevron-up" />
                        : <i className="arrow-icon fa-regular fa-chevron-down" />}
                </Button>
            </Menu>
        </div>
    )
}

export default SplitButton
